"use client";

import React, { useState } from "react";
import BaseButton, { BaseButtonProps } from "./BaseButton";

export type ButtonProps = BaseButtonProps;

const Button: React.FC<ButtonProps> = (props) => {
  return <BaseButton {...props} variant={props.variant || "gail2"} />;
};

export default Button;
